import { createStackNavigator } from "@react-navigation/stack";
import React from "react";
import OrderList from "../components/orders/orderList";
import OrderDetails from "../components/orders/orderDetails";
import OrderTab from "./orderScreen";
import NewSellscreen from "../components/newSellscreen/newSellscreen";

const OrdersStack = () => {
    const OrderStack = createStackNavigator()
    return (
        <OrderStack.Navigator
            initialRouteName="OrderList"
            screenOptions={{ headerShown: false }}>
            <OrderStack.Screen component={OrderTab} name="OrderList" />
            <OrderStack.Screen component={OrderList} name="RestoreOrderList" />
            <OrderStack.Screen component={OrderDetails} name="OrderDetails" />
            <OrderStack.Screen name="NewSellScreen" component={NewSellscreen} />
        </OrderStack.Navigator>
    )
}

export default OrdersStack